export default __webpack_public_path__ + "static/media/home_project.995fe41c.jpg";